import { Wrench } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface MaintenancePageProps {
  /** Override the default message (used by both site-wide and per-page modes). */
  message?: string
  /** 'maintenance' shows the wrench/working copy, 'coming-soon' shows neutral copy. */
  variant?: 'maintenance' | 'coming-soon'
}

export default function MaintenancePage({ message, variant = 'maintenance' }: MaintenancePageProps) {
  const { t } = useTranslation()
  const headingKey = variant === 'coming-soon' ? 'system.comingSoon.heading' : 'system.maintenance.heading'
  const bodyKey = variant === 'coming-soon' ? 'system.comingSoon.body' : 'system.maintenance.body'

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6 py-20">
      <Wrench size={40} className="text-gold mb-6" aria-hidden="true" />
      <h1 className="font-display text-4xl md:text-5xl text-mocha mb-4">
        {t(headingKey)}
      </h1>
      <p className="font-body text-mocha/60 text-lg max-w-md">
        {message ?? t(bodyKey)}
      </p>
    </div>
  )
}
